export default class DedicationForm {
    static init(): void {

        const forms = document.querySelectorAll('.dedication-form') as NodeListOf<HTMLFormElement>;
        const bookingForm = document.querySelector('.booking-reservation-form') as HTMLFormElement;
        if (!bookingForm) return;

        const step2 = document.querySelectorAll('[data-booking-form-step="2"]');
        const step3 = document.querySelectorAll('[data-booking-form-step="3"]');

        const nextStepButton = document.querySelector('[data-booking-form-step="2"] .booking-reservation__button--next') as HTMLButtonElement;
        const prevStepButton = document.querySelector('[data-booking-form-step="3"] .booking-reservation__button--prev') as HTMLButtonElement;

        const bookingSteps = document.querySelector('.booking-steps') as HTMLDivElement;
        const bookingStepsItems = bookingSteps.querySelectorAll('.booking-steps__item') as NodeListOf<HTMLDivElement>;
        const bookingStepsItem2 = bookingStepsItems[1];
        const bookingStepsItem3 = bookingStepsItems[2];

        if (!step2 || !step3 || !nextStepButton) {
            return;
        }

        forms.forEach(form => {
            const textareas = form.querySelectorAll('.dedication-form__dedication') as NodeListOf<HTMLTextAreaElement>;

            textareas.forEach(textarea => {
                const parent = textarea.closest('.dedication-form__dedication-row') as HTMLDivElement;
                const counters = parent.querySelector('.dedication-form__counter[for="' + textarea.getAttribute('id') + '"]') as HTMLDivElement;
                const counterRows = counters.querySelector('[data-counter="rows"]') as HTMLSpanElement;
                const counterChars = counters.querySelector('[data-counter="chars"]') as HTMLSpanElement;
                const textAreaName = textarea.getAttribute('name') as string;
                const bookingDedication = bookingForm.querySelector('[name="' + textAreaName + '"]') as HTMLInputElement;

                textarea.addEventListener('input', () => {
                    // max 50 characters by line
                    const lines = textarea.value.split('\n');
                    lines.forEach((line, index) => {
                        console.log(line.length);
                        if (line.length > 50) {
                            lines[index] = line.slice(0, 50);
                            textarea.value = lines.join('\n');
                        }
                        counterChars.textContent = `${lines[index].length}/50 na řádek`;

                        if (lines[index].length >= 50) {
                            counterChars.classList.add('error');
                        } else {
                            counterChars.classList.remove('error');
                        }
                    });
                    counterRows.textContent = `${lines.length}/4 řádky`;

                    if (lines.length >= 4) {
                        counterRows.classList.add('error');
                    } else {
                        counterRows.classList.remove('error');
                    }

                    // max 4 rows by enter key
                    const rows = textarea.value.split('\n').length;
                    if (rows > 4) {
                        textarea.value = textarea.value.split('\n').slice(0, 4).join('\n');
                    }

                    bookingDedication.value = textarea.value;
                });

                // max 4 rows by enter key
                textarea.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter' && textarea.value.split('\n').length >= 4) {
                        e.preventDefault();
                    }
                });

                nextStepButton.addEventListener('click', () => {
                    step2.forEach(el => el.classList.add('d-none'));
                    step3.forEach(el => el.classList.remove('d-none'));
                    bookingStepsItem2.classList.remove('booking-steps__item--active');
                    bookingStepsItem2.classList.add('booking-steps__item--disabled');
                    bookingStepsItem3.classList.add('booking-steps__item--active');
                });

                prevStepButton.addEventListener('click', () => {
                    step2.forEach(el => el.classList.remove('d-none'));
                    step3.forEach(el => el.classList.add('d-none'));
                    bookingStepsItem2.classList.add('booking-steps__item--active');
                    bookingStepsItem2.classList.remove('booking-steps__item--disabled');
                    bookingStepsItem3.classList.remove('booking-steps__item--active');
                });
            });

            // DEDICATION TYPE
            const dedicationType = form.querySelector('.dedication-form__type') as HTMLElement | null;
            if (!dedicationType) return;
            const typeInputs = dedicationType.querySelectorAll('input') as NodeListOf<HTMLInputElement>;
            const bookingSelection = bookingForm.querySelector('[name="dedications[dedication_type]"]') as HTMLInputElement;

            const differentRows = form.querySelectorAll('.dedication-form__dedication-row[data-dedication-type="different"]') as NodeListOf<HTMLDivElement>;
            const sameRows = form.querySelectorAll('.dedication-form__dedication-row[data-dedication-type="same"]') as NodeListOf<HTMLDivElement>;

            typeInputs.forEach(input => {
                input.addEventListener('change', () => {
                    differentRows.forEach(row => row.classList.add('d-none'));
                    sameRows.forEach(row => row.classList.add('d-none'));

                    if (input.checked && input.value === 'different') {
                        bookingSelection.value = 'different';
                        differentRows.forEach(row => {
                            row.classList.remove('d-none');
                        });
                    }

                    if (input.checked && input.value === 'same') {
                        bookingSelection.value = 'same';
                        sameRows.forEach(row => {
                            row.classList.remove('d-none');
                        });
                    }

                });
            });


        });

    }
}
